/* Noble Tech theme — interactions */
(function () {
  'use strict';
  var NT = window.NT || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches && !reduce;

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = NT.money || 'Rs.{{amount}}';
    var n = (cents / 100);
    var withDelims = function (num, dec) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withDelims(n, 0);
      if (k === 'amount_with_comma_separator') return withDelims(n, 2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0);
      return withDelims(n, 2);
    });
    return out.replace(/[.,]00(?!\d)/, '');
  }

  /* ---------- toast + cart count ---------- */
  var toast = $('#toast'), toastT = $('#toast-t'), toastTimer;
  function say(msg) {
    if (!toast) return;
    toastT.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }
  function setCount(n) {
    var cc = $('#cc'); if (!cc) return;
    cc.textContent = n;
    if (n > 0) cc.removeAttribute('data-empty'); else cc.setAttribute('data-empty', '');
    cc.classList.remove('bump'); void cc.offsetWidth; cc.classList.add('bump');
  }
  function addToCart(id, qty) {
    return fetch((NT.routes ? NT.routes.cart_add : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    }).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) { setCount(cart.item_count); return cart; });
  }

  /* ---------- header + mobile menu ---------- */
  var hdr = $('#hdr');
  if (hdr) addEventListener('scroll', function () { hdr.classList.toggle('scrolled', scrollY > 10); }, { passive: true });
  var mnav = $('#mnav'), mbtn = $('#menu-btn');
  function closeMenu() { if (!mnav) return; mnav.classList.remove('open'); mbtn && mbtn.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; setTimeout(function () { mnav.hidden = true; }, 350); }
  if (mnav && mbtn) {
    mbtn.addEventListener('click', function () {
      mnav.hidden = false; requestAnimationFrame(function () { mnav.classList.add('open'); });
      mbtn.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
    });
    $$('[data-close]', mnav).forEach(function (b) { b.addEventListener('click', closeMenu); });
    $$('a', mnav).forEach(function (a) { a.addEventListener('click', closeMenu); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mnav.hidden) closeMenu(); });
  }

  /* ---------- hero motion ---------- */
  var lap = $('#laptop'), stage = $('#stage'), hero = $('.hero');
  if (fine && lap && stage && hero) {
    hero.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      lap.style.transform = 'rotateX(' + (14 - y * 8) + 'deg) rotateY(' + (-18 + x * 14) + 'deg) rotateZ(2deg)';
    });
  }
  if (fine) $$('.magnet').forEach(function (b) {
    b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * .18 + 'px,' + (e.clientY - r.top - r.height / 2) * .3 + 'px)'; });
    b.addEventListener('pointerleave', function () { b.style.transform = ''; });
  });
  function bindTilt(root) {
    if (!fine) return;
    $$('.card', root).forEach(function (c) {
      if (c._tilt) return; c._tilt = 1;
      c.addEventListener('pointermove', function (e) { var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; c.style.transform = 'perspective(900px) rotateY(' + x * 6 + 'deg) rotateX(' + (-y * 6) + 'deg) translateY(-4px)'; });
      c.addEventListener('pointerleave', function () { c.style.transform = ''; });
    });
  }
  bindTilt(document);

  /* ---------- scroll reveal ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var els = $$('.rv-target').filter(function (el) { return el.getBoundingClientRect().top > innerHeight; });
    els.forEach(function (el) { el.classList.add('rv-pre'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, sib = $$('.rv-target', el.parentElement).filter(function (c) { return c.parentElement === el.parentElement; });
        el.style.transitionDelay = Math.max(0, sib.indexOf(el)) * 80 + 'ms';
        el.classList.add('rv-in'); el.classList.remove('rv-pre'); io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    $$('[data-process]').forEach(function (p) {
      new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { p.classList.add('go'); o.disconnect(); } }, { threshold: .3 }).observe(p);
    });
  } else { $$('[data-process]').forEach(function (p) { p.classList.add('go'); }); }

  /* ---------- tabs + grid filtering ---------- */
  var params = new URLSearchParams(location.search);
  function filterGrid(grid, cat, limit) {
    var min = Number(params.get('min')) || 0, max = Number(params.get('max')) || 0, shown = 0;
    $$('[data-card]', grid).forEach(function (c) {
      var ok = (cat === 'all' || c.dataset.cat === cat);
      var price = Number(c.dataset.price) || 0;
      if (grid.hasAttribute('data-coll-grid')) { if (min && price < min) ok = false; if (max && price >= max) ok = false; }
      if (ok && limit && shown >= limit) ok = false;
      c.hidden = !ok;
      if (ok) { shown++; c.classList.remove('enter'); void c.offsetWidth; c.classList.add('enter'); c.style.animationDelay = (shown - 1) * 50 + 'ms'; }
    });
    var empty = grid.parentElement.querySelector('[data-grid-empty]');
    if (empty) empty.hidden = shown > 0;
  }
  $$('[data-tabs]').forEach(function (tabs) {
    var pill = $('[data-pill]', tabs), btns = $$('button', tabs);
    var section = tabs.closest('section'), grid = section && $('[data-grid]', section);
    var limit = grid ? Number(grid.dataset.limit) || 0 : 0;
    function place(b) { if (!pill || !b) return; pill.style.width = b.offsetWidth + 'px'; pill.style.transform = 'translateX(' + b.offsetLeft + 'px)'; }
    function pick(cat, scroll) {
      var b = btns.filter(function (x) { return x.dataset.cat === cat; })[0] || btns[0];
      btns.forEach(function (x) { x.setAttribute('aria-selected', x === b); });
      place(b);
      if (grid) filterGrid(grid, b.dataset.cat, limit);
      if (scroll) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.cat, true); if (tabs.hasAttribute('data-filter-tabs')) { params.set('cat', b.dataset.cat); history.replaceState(null, '', '?' + params.toString()); } }); });
    addEventListener('resize', function () { place(btns.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0]); });
    var start = tabs.hasAttribute('data-filter-tabs') ? (params.get('cat') || 'all') : 'chromebooks';
    pick(start);
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(function () { pick(btns.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0].dataset.cat); });
  });
  var note = $('[data-price-note]');
  if (note && (params.get('min') || params.get('max'))) {
    note.hidden = false;
    note.innerHTML = 'Showing ' + (params.get('min') && params.get('min') !== '0' ? 'Rs ' + Number(params.get('min')).toLocaleString('en-PK') + ' and above' : '') + (params.get('min') && params.get('min') !== '0' && params.get('max') ? ', ' : '') + (params.get('max') ? 'under Rs ' + Number(params.get('max')).toLocaleString('en-PK') : '') + ' · <a href="' + location.pathname + '">Clear</a>';
  }
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { params.set('sort_by', sort.value); location.search = params.toString(); });

  /* ---------- product cards: variant chips + quick add ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.vchip');
    if (chip) {
      e.preventDefault();
      var card = chip.closest('[data-card]'), data = $('[data-variants]', card);
      if (!data) return;
      var vs = JSON.parse(data.textContent), val = chip.dataset.val;
      var match = vs.filter(function (v) { return v.option1 === val && v.available; })[0] || vs.filter(function (v) { return v.option1 === val; })[0];
      if (!match) return;
      $$('.vchip', card).forEach(function (b) { b.setAttribute('aria-pressed', b === chip); });
      var box = $('[data-price-box]', card);
      box.innerHTML = '<b>' + money(match.price) + '</b>' + (match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s>' : '');
      var q = $('[data-quick]', card); if (q) q.dataset.quick = match.id;
      var sv = $('[data-save]', card); if (sv) { if (match.compare_at_price > match.price) { sv.hidden = false; sv.textContent = 'Save ' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%'; } else sv.hidden = true; }
      return;
    }
    var quick = e.target.closest('[data-quick]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      addToCart(quick.dataset.quick, 1).then(function () { say(quick.dataset.name + ' added to cart'); })
        .catch(function (err) { say(err.message); })
        .then(function () { quick.disabled = false; });
    }
  });

  /* ---------- product page ---------- */
  var pd = $('[data-product]');
  if (pd) {
    var product = JSON.parse($('[data-product-json]', pd).textContent);
    var form = $('#pd-form'), idInput = $('[data-variant-id]', form), ret = $('[data-return]', form);
    var priceBox = $('[data-price-box]', pd), stock = $('[data-stock]', pd), addB = $('[data-add]', pd), buyB = $('[data-buy]', pd);
    var mainImg = $('#pd-img'), waLink = $('[data-wa-link]', pd), qty = $('[data-qty]', pd);
    var current = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];
    function selected() { return $$('.pd-vars', pd).map(function (g) { var b = $('[aria-checked="true"]', g); return b ? b.dataset.value : null; }); }
    function swapImg(src) { if (!mainImg || !src) return; mainImg.style.opacity = 0; setTimeout(function () { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.style.opacity = 1; }, 160); }
    function render(v) {
      current = v; idInput.value = v.id;
      priceBox.innerHTML = '<b>' + money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><span class="save-amt">You save ' + money(v.compare_at_price - v.price) + '</span>' : '');
      var sv = $('[data-save]', pd);
      if (sv) { if (v.compare_at_price > v.price) { sv.className = 'badge save'; sv.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } else { sv.className = ''; sv.textContent = ''; } }
      stock.textContent = v.available ? 'In stock · ships right after confirmation' : 'Sold out';
      if (v.available) stock.removeAttribute('data-out'); else stock.setAttribute('data-out', '');
      addB.disabled = buyB.disabled = !v.available;
      v.options.forEach(function (o, i) { var dd = $('[data-config-val="' + i + '"]', pd); if (dd && dd.textContent !== o) { dd.textContent = o; var row = dd.parentElement; row.classList.remove('chg'); void row.offsetWidth; row.classList.add('chg'); } });
      if (v.featured_image) swapImg(v.featured_image.src);
      if (waLink) waLink.href = 'https://wa.me/' + pd.dataset.wa + '?text=' + encodeURIComponent('Hi Noble Tech, I would like to order the ' + pd.dataset.name + ' (' + v.title + ') for ' + money(v.price) + '.');
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    $$('.pd-vars', pd).forEach(function (g, gi) {
      $$('button', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', g).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
          var opts = selected();
          var v = product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
          if (!v) { v = product.variants.filter(function (v) { return v.options[gi] === b.dataset.value; })[0]; if (v) v.options.forEach(function (o, i) { var gb = $$('.pd-vars', pd)[i]; $$('button', gb).forEach(function (x) { x.setAttribute('aria-checked', x.dataset.value === o); }); }); }
          if (v) render(v);
        });
      });
    });
    $$('.pd-th', pd).forEach(function (t) {
      t.addEventListener('click', function () { $$('.pd-th', pd).forEach(function (x) { x.setAttribute('aria-pressed', x === t); }); swapImg(t.dataset.src); });
    });
    $$('[data-q]', pd).forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.min(5, Math.max(1, (Number(qty.value) || 1) + Number(b.dataset.q))); }); });
    form.addEventListener('submit', function (e) {
      var isBuy = e.submitter && e.submitter.hasAttribute('data-buy');
      if (isBuy) { ret.value = '/checkout'; return; }
      e.preventDefault(); ret.value = '';
      addB.disabled = true;
      addToCart(idInput.value, qty.value).then(function () { say(pd.dataset.name + ' added to cart'); })
        .catch(function (err) { say(err.message); }).then(function () { addB.disabled = !current.available; });
    });
  }

  /* ---------- cart page ---------- */
  $$('[data-cq]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input');
      input.value = Math.max(0, (Number(input.value) || 0) + Number(b.dataset.cq));
      b.closest('form').submit();
    });
  });

  /* ---------- compare quiz ---------- */
  $$('[data-quiz]').forEach(function (q) {
    var sec = q.closest('section');
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', q).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        $$('[data-opt]', sec).forEach(function (o) { o.classList.toggle('chosen', o.dataset.opt === b.dataset.pick); });
      });
    });
  });

  /* ---------- FAQ ---------- */
  $$('[data-faq] .q > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = b.parentElement, open = q.getAttribute('open-state') === 'true';
      $$('.q', q.parentElement).forEach(function (x) { x.setAttribute('open-state', 'false'); $('button', x).setAttribute('aria-expanded', 'false'); });
      if (!open) { q.setAttribute('open-state', 'true'); b.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ---------- copy number ---------- */
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = $('[data-ph]', b.parentElement);
      var sel = function () { var r = document.createRange(); r.selectNodeContents(t); var s = getSelection(); s.removeAllRanges(); s.addRange(r); };
      try { navigator.clipboard.writeText(t.textContent.trim()).then(function () { b.textContent = 'Copied'; }, sel); } catch (_) { sel(); }
    });
  });

  /* ---------- offers ---------- */
  var liveBox = $('[data-live-offers]'), pastBox = $('[data-past-offers]');
  if (liveBox) {
    var HR = 36e5;
    var check = function () {
      var now = Date.now(), any = false;
      $$('[data-offer]', liveBox).forEach(function (o) {
        var ends = Date.parse(o.dataset.ends), starts = o.dataset.starts ? Date.parse(o.dataset.starts) : 0;
        if (starts && now < starts) { o.hidden = true; return; }
        if (!isNaN(ends) && now >= ends) {
          var tpl = $('template[data-past-card]', o);
          if (tpl && pastBox) pastBox.insertBefore(tpl.content.cloneNode(true), pastBox.firstChild);
          o.remove(); return;
        }
        o.hidden = false; any = true;
        var cd = $('.cd', o), left = Math.max(0, ends - now);
        var v = { d: Math.floor(left / 864e5), h: Math.floor(left / HR) % 24, m: Math.floor(left / 6e4) % 60, s: Math.floor(left / 1e3) % 60 };
        cd.classList.toggle('urgent', left < 24 * HR);
        $$('b', cd).forEach(function (b) {
          var t = String(v[b.dataset.u]).padStart(2, '0');
          if (b.textContent !== t) { b.textContent = t; if (!reduce) { b.classList.remove('tick'); void b.offsetWidth; b.classList.add('tick'); } }
        });
      });
      var none = $('[data-no-live]', liveBox); if (none) none.hidden = any;
    };
    $$('[data-ends-text]').forEach(function (el) {
      var d = new Date(el.dataset.endsText);
      if (!isNaN(d)) el.textContent = 'Ends ' + d.toLocaleString('en-PK', { weekday: 'long', day: 'numeric', month: 'long', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Karachi' }) + ', or earlier if stock runs out.';
    });
    check(); setInterval(check, 1000);
  }

  /* ---------- order tracking ---------- */
  var tr = $('[data-track]');
  if (tr) {
    var API = tr.dataset.api, WA = tr.dataset.wa;
    var tf = $('[data-track-form]', tr), tq = $('input', tf), hint = $('[data-hint]', tr), head = $('[data-head]', tr), tl = $('[data-tl]', tr);
    var STEP = { pending: 0, assigned: 0, no_answer: 0, callback: 0, confirmed: 1, ready_for_dispatch: 2, booked: 3, dispatched: 3, in_transit: 4, out_for_delivery: 5, delivered: 6 };
    var NOTE = { no_answer: 'We tried calling to confirm your order. Please pick up, or message us on WhatsApp.', callback: 'We will call you again at the time you asked.', confirmed: 'Confirmed. Your order is being packed.', ready_for_dispatch: 'Packed and waiting for courier pickup.', booked: 'Booked with the courier. Pickup is on the way.', delivered: 'Delivered. Thank you for shopping with Noble Tech.' };
    var STOP = { returned: 'This order was returned to us.', cancelled: 'This order was cancelled.', failed: 'Delivery attempt failed. Our team will contact you.', fake: 'We could not verify this order.', wrong_number: 'We could not reach you on this number. Please WhatsApp us.' };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var kind = function (q) { var d = q.replace(/\D/g, ''); if (/^#/.test(q.trim()) || (d.length >= 3 && d.length <= 6)) return 'order'; if (/^(92|0)?3\d{9}$/.test(d)) return 'phone'; if (d.length >= 10) return 'tracking'; return ''; };
    var wa = function (text) { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(text); };
    tq.addEventListener('input', function () {
      var k = kind(tq.value); hint.dataset.k = k;
      hint.textContent = k === 'order' ? 'Looks like an order number' : k === 'phone' ? 'Looks like a phone number' : k === 'tracking' ? 'Looks like a PostEx tracking number' : 'Use the number from your order confirmation SMS or WhatsApp.';
    });
    var fmt = function (iso) { try { return new Date(iso).toLocaleString('en-PK', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }); } catch (_) { return ''; } };
    var clear = function () { $$('li', tl).forEach(function (s) { s.className = ''; var t = $('time', s); if (t) t.remove(); }); };
    function show(o) {
      clear(); tl.classList.toggle('stopped', !!STOP[o.status]);
      var at = {}; (o.history || []).forEach(function (h) { var k = STEP[h.status]; if (k !== undefined) at[k] = h.at; });
      var msg = STOP[o.status] || NOTE[o.status];
      head.innerHTML = '<b>Order ' + esc(o.order) + (o.courier ? ' · ' + esc(o.courier) : '') + '</b><small>' + esc((o.items || []).join(', ')) + (o.city ? ' · to ' + esc(o.city) : '') + '</small>' +
        (msg ? '<p class="tl-note' + (STOP[o.status] ? ' bad' : '') + '">' + msg + '</p>' : '') +
        (o.tracking_number ? '<small class="mono">CN ' + esc(o.tracking_number) + (o.tracking_url ? ' · <a href="' + esc(o.tracking_url) + '" target="_blank" rel="noopener">PostEx page</a>' : '') + '</small>' : '');
      var steps = $$('li', tl), upto = STEP[o.status] != null ? STEP[o.status] : 0, i = 0;
      (function tick() {
        if (i > 0) steps[i - 1].className = 'done';
        steps[i].className = (i === upto && upto < 6) ? 'now' : 'done';
        if (at[i]) { var t = document.createElement('time'); t.textContent = fmt(at[i]); steps[i].appendChild(t); }
        i++; if (i <= upto) setTimeout(tick, reduce ? 0 : 220);
      })();
    }
    tf.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = tq.value.trim(), k = kind(q);
      if (!q) { hint.textContent = 'Please enter your order number, phone or tracking number.'; hint.dataset.k = 'err'; tq.focus(); return; }
      clear();
      if (!API) {
        if (k === 'tracking') {
          var d = q.replace(/\D/g, '');
          head.innerHTML = '<b>Tracking ' + esc(d) + '</b><small>Live status from PostEx:</small><p class="tl-note"><a href="https://postex.pk/tracking?cn=' + d + '" target="_blank" rel="noopener">Open PostEx tracking</a></p>';
        } else {
          head.innerHTML = '<b>We’ll check it for you</b><small>Send us your ' + (k === 'phone' ? 'phone number' : 'order number') + ' on WhatsApp and our team will reply with the status.</small><p class="tl-note"><a href="' + wa('Hi Noble Tech, please share the status of my order: ' + q) + '" target="_blank" rel="noopener">Ask on WhatsApp</a></p>';
        }
        return;
      }
      head.innerHTML = '<b>Checking…</b><small>Looking up your order</small>'; tl.classList.add('loading');
      fetch(API + (API.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q), { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (res) {
          tl.classList.remove('loading');
          if (!res.found || !res.orders || !res.orders.length) { head.innerHTML = '<b>No order found</b><small>Check the number, or <a href="' + wa('Hi Noble Tech, I could not find my order: ' + q) + '" target="_blank" rel="noopener">message us on WhatsApp</a>.</small>'; return; }
          show(res.orders[0]);
          if (res.orders.length > 1) {
            var pick = document.createElement('div'); pick.className = 'tl-pick';
            res.orders.forEach(function (o) { var b = document.createElement('button'); b.type = 'button'; b.textContent = o.order; b.addEventListener('click', function () { show(o); head.appendChild(pick); }); pick.appendChild(b); });
            head.appendChild(pick);
          }
        })
        .catch(function () { tl.classList.remove('loading'); head.innerHTML = '<b>Tracking is busy right now</b><small>Please try again in a minute, or <a href="' + wa('Hi Noble Tech, please share the status of my order: ' + q) + '" target="_blank" rel="noopener">message us on WhatsApp</a>.</small>'; });
    });
  }
})();
